/**
 * Bug Constants
 * Note: Environment options are imported from testRunConstants.js to avoid duplication
 */

// Bug Status Options
export const BUG_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
  REOPENED: 'reopened',
  BLOCKED: 'blocked',
  NOT_A_BUG: 'not_a_bug',
  SETUP_ISSUE: 'setup_issue'
}

export const BUG_STATUS_OPTIONS = [
  { value: BUG_STATUS.OPEN, label: 'Open', color: 'red' },
  { value: BUG_STATUS.IN_PROGRESS, label: 'In Progress', color: 'blue' },
  { value: BUG_STATUS.RESOLVED, label: 'Resolved', color: 'green' },
  { value: BUG_STATUS.CLOSED, label: 'Closed', color: 'gray' },
  { value: BUG_STATUS.REOPENED, label: 'Reopened', color: 'orange' },
  { value: BUG_STATUS.BLOCKED, label: 'Blocked', color: 'purple' },
  { value: BUG_STATUS.NOT_A_BUG, label: 'Not a Bug', color: 'yellow' },
  { value: BUG_STATUS.SETUP_ISSUE, label: 'Setup Issue', color: 'cyan' }
]

// Bug Priority Options
export const BUG_PRIORITY = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
}

export const BUG_PRIORITY_OPTIONS = [
  { value: BUG_PRIORITY.CRITICAL, label: 'Critical' },
  { value: BUG_PRIORITY.HIGH, label: 'High' },
  { value: BUG_PRIORITY.MEDIUM, label: 'Medium' },
  { value: BUG_PRIORITY.LOW, label: 'Low' }
]

// Bug Type Options
export const BUG_TYPE = {
  BUG: 'bug',
  FEATURE: 'feature',
  ENHANCEMENT: 'enhancement',
  TASK: 'task'
}

export const BUG_TYPE_OPTIONS = [
  { value: BUG_TYPE.BUG, label: 'Bug' },
  { value: BUG_TYPE.FEATURE, label: 'Feature Request' },
  { value: BUG_TYPE.ENHANCEMENT, label: 'Enhancement' },
  { value: BUG_TYPE.TASK, label: 'Task' }
]

// Bug Severity Options
// Must match backend DTO: critical, major, moderate, minor
export const BUG_SEVERITY = {
  CRITICAL: 'critical',
  MAJOR: 'major',
  MODERATE: 'moderate',
  MINOR: 'minor'
}

export const BUG_SEVERITY_OPTIONS = [
  { value: BUG_SEVERITY.CRITICAL, label: 'Critical' },
  { value: BUG_SEVERITY.MAJOR, label: 'Major' },
  { value: BUG_SEVERITY.MODERATE, label: 'Moderate' },
  { value: BUG_SEVERITY.MINOR, label: 'Minor' }
]

// Environment Options
// Re-export from testRunConstants.js to avoid duplication
export { TEST_RUN_ENVIRONMENTS as ENVIRONMENT_OPTIONS } from './testRunConstants'

// Icon constant for Bug
export const BUG_ICON = 'BUG'

// Legacy ENVIRONMENT constant for backward compatibility
export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  VERSIONED_STAGING: 'versioned_staging',
  DEFAULT_STAGING: 'default_staging',
  INTEROP: 'interop',
  BETA: 'beta',
  PRODUCTION: 'production'
}

// Browser Options
export const BROWSER = {
  CHROME: 'chrome',
  FIREFOX: 'firefox',
  SAFARI: 'safari',
  EDGE: 'edge',
  OTHER: 'other'
}

export const BROWSER_OPTIONS = [
  { value: BROWSER.CHROME, label: 'Chrome' },
  { value: BROWSER.FIREFOX, label: 'Firefox' },
  { value: BROWSER.SAFARI, label: 'Safari' },
  { value: BROWSER.EDGE, label: 'Edge' },
  { value: BROWSER.OTHER, label: 'Other' }
]

// Operating System Options
export const OS = {
  WINDOWS: 'windows',
  MACOS: 'macos',
  LINUX: 'linux',
  IOS: 'ios',
  ANDROID: 'android',
  OTHER: 'other'
}

export const OS_OPTIONS = [
  { value: OS.WINDOWS, label: 'Windows' },
  { value: OS.MACOS, label: 'macOS' },
  { value: OS.LINUX, label: 'Linux' },
  { value: OS.IOS, label: 'iOS' },
  { value: OS.ANDROID, label: 'Android' },
  { value: OS.OTHER, label: 'Other' }
]

